import script from "./vms.vue?vue&type=script&lang=js"
export * from "./vms.vue?vue&type=script&lang=js"

import "./vms.vue?vue&type=style&index=0&id=4e06061b&lang=css"
import "./vms.vue?vue&type=style&index=1&id=4e06061b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e06061b"]])

export default __exports__